module.exports = __webpack_public_path__ + "img/ss2.5b310c0b.png";